import { XMarkIcon } from '@heroicons/react/20/solid';

export default function ClearableInput({ placeholder, inputClassName, divClassName, onChange, value }: 
    { placeholder: string, inputClassName: string, divClassName: string, onChange: (value: string) => void, value: string }) {
    return (
        <div className={`relative flex ${divClassName}`}>
            <input
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                className={`flex-1 ${inputClassName}`}
            />
            {value && (
                <button
                    onClick={() => onChange('')}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                    <XMarkIcon className="h-5 w-5" />
                </button>
            )}
        </div>
    );
}
